import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { installClickTracker, trackPageview } from "@/lib/analytics";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Fire GA4 page_view after title updates (Helmet applies synchronously in most cases)
    const t = setTimeout(trackPageview, 60);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const uninstall = installClickTracker();
    return uninstall;
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#0a0a0c] text-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
